/**
 * @fileoverview Sales Pipeline KPI query hook.
 * @description Wraps GET /sales/prospects/summary in a TanStack query.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getProspectSummary } from '@/features/sales/services/prospects.service'

/**
 * @description Fetches the pipeline KPI cards.
 * @returns {ReturnType<typeof useQuery>} The query (data is the summary).
 */
export function useProspectSummary() {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.summary,
    queryFn: getProspectSummary,
  })
}
